import React, { Component } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../assets/stylesheets/ProfileSlide/AccountLevel.scss';
import ProgressBar  from 'react-bootstrap/ProgressBar';
import Header from '../Units/Header';

const AccountLevel = ({}) => {

    const { t } = useTranslation();
    
    return(
        <div className={`accountLevel`}>
            <Header backTo={'/profile'}/>
            <div className={`level`}>
                <span>4</span>
            </div>
            <p className={`accountLevelText`}>{t('level.accountLevel')}</p>
            <div className={`progressBar`}>
                <ProgressBar 
                className={`progress`}
                striped
                now={50}  />
                <span className={`nextLevel`}>5</span>
            </div>
            <div className={`xpContainer`}>
                <span className={`current`}>
                    {t('level.currentXp')}: 500
                </span>
                <span className={`required`}>
                   {t('level.requiredXp')}: 400
                </span>
            </div>
            <div className={`centeredText`}>
                <p>
                   {t('level.gainXp')}
                </p>
            </div>
            <div className={`horizontalLine`}></div>
            <div className={`centeredText`}>
                <p>{t('level.levelRewards', { level: 5 })} </p>
            </div>
            <div className={`balanceContainer`}>
                <div className={`balanceItem`}>
                    <div className="diamondBalance">
                        <span className={'diamondIcon'}></span>
                        <span className="balanceNumber">500</span>
                    </div>
                </div>
                <div className={`balanceItem`}>
                    <div className="coinBalance">
                        <span className={'coinIcon'}></span>
                        <span className="balanceNumber">500</span>
                    </div>
                </div>
                </div>
        </div>
    )
}
export default AccountLevel;